<!-- Display Mode -->
@if (!editMode) {
  <div
    fxLayout="column"
    class="box is-elevation-4">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="tts-header">
      <div
        class="tts-header-number"
        fxLayout="row"
        fxLayoutAlign="center center">
        {{ index + 1 }}
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="ml-3">
        <i class="icon icon-small_bullhorn tts-header-icon"></i>
        <div class="tts-header-text">{{ 'COMMUNICATIONS.NOTIFICATION-MESSAGE' | translate }}</div>
      </div>
    </div>
    <div
      class="tts-body"
      [innerHTML]="messageText | safeHtml"></div>
  </div>
}

<!-- Edit Settings -->
@if (editMode) {
  <div></div>
}
